// import { allapiAction } from "@/Redux/common/action";
// import { URL } from "@/Redux/common/url";
// import { useRouter } from "next/router";
import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LatestListing from "./LatestListing";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import { Link, useNavigate, useParams } from "react-router-dom";
import SellerHeader from "../Layout/SellerHeader";
import TruncateText from "../TruncateText/TruncateText";
import HomeSlider from "../Home/HomeSlider";
import { Button, Col, Input, Modal, Row } from "antd";
import { toast } from "react-toastify";

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  MailruShareButton,
  MailruIcon,
  OKShareButton,
  OKIcon,
  PinterestShareButton,
  PinterestIcon,
  PocketShareButton,
  PocketIcon,
  RedditShareButton,
  RedditIcon,
  TelegramShareButton,
  TelegramIcon,
  TumblrShareButton,
  TumblrIcon,
} from "react-share";
import RecentProduct from "./RecentProduct";
import Seo from "../Seo/Seo";
import InfiniteScroll from "react-infinite-scroll-component";
import CoustomImg from "../CoustomImg/CoustomImg";
import HomeSliderSeller from "../Home/HomeSliderSeller";
import CoustomberHeader from "../Layout/CoustomberHeader";
import Category from "../Home/Category";
import FeProduct from "../Home/FeProduct";

function SellerStore({}) {
  const router = useNavigate();
  // const { id } = router.query;
  const { id } = useParams();
  const dispatch = useDispatch();
  const get_like_list = useSelector((state) =>
    state.allapi.get_like_list ? state.allapi.get_like_list : {},
  );
  const vendorDetails = useSelector((state) =>
    state.allapi.get_seller_details ? state.allapi.get_seller_details : {},
  );
  const get_home_all_pro = useSelector((state) =>
    state?.allapi?.get_home_all_pro ? state?.allapi?.get_home_all_pro : {},
  );
  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valueuser, setvalueuser] = useState({});
  const [postList, setpostList] = useState({});
  console.log(postList);
  console.log(postList?.listing);
  const prolist = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      id: id,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const res2 = await fetch(
      URL.API_BASE_URL + `${URL.getvendorprofileproduct}`,
      requestOptions,
    );

    const events2 = await res2.json();

    const postData2 = events2?.data;
    console.log(postData2);
    setpostList(postData2);
  };

  useEffect(() => {
    prolist();
    dispatch(allapiAction.gethomePro({}));
    dispatch(allapiAction.getsliderList2Vendor({ page: "home", _id: id }));
    // dispatch(allapiAction.getsliderList({ page: "home" }));
    if (typeof window !== "undefined") {
      setValue(localStorage.getItem("access_token"));
      setValuevendor(localStorage.getItem("access_token_vendor"));
      const userDeatail = localStorage.getItem("access_user");

      if (userDeatail) {
        const obj = JSON.parse(userDeatail);
        setvalueuser(obj);
      }
    } else {
      setValue("");
      setValuevendor("");
    }
  }, []);
  useEffect(() => {
    if (id) {
      if (value || valuevendor) {
        dispatch(allapiAction.userlikeget({ user_id: id }));
      }

      return () => {};
    }
  }, [id, valuevendor, value]);

  const hendletofollow = async () => {
    await dispatch(allapiAction.userfollownow({ user_id: id }));
    dispatch(allapiAction.getsellerprofile({ id: id }));
    return () => {};
  };

  const hendletoLike = async () => {
    await dispatch(allapiAction.userlikenow({ user_id: id }));
    dispatch(allapiAction.getsellerprofile({ id: id }));
    return () => {};
  };

  const [windowWidth, setWindowWidth] = useState(600);

  useLayoutEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const [statusDataBoxReturn, setstatusDataBoxReturn] = useState(false);
  const [enquiryData, setenquiryData] = useState({});

  const onChangeData = (e) => {
    setenquiryData({ ...enquiryData, [e.target.name]: e.target.value });
  };
  const hendletoSubmitEnquiry = async () => {
    if (!enquiryData?.name) {
      toast?.error("please enter your name");
      return;
    }
    if (!enquiryData?.number) {
      toast?.error("please enter your number");
      return;
    }
    if (!enquiryData?.address) {
      toast?.error("please enter your address");
      return;
    }

    const response = await dispatch(
      allapiAction.emailenquirysubmit({
        sellerId: vendorDetails?._id,
        sellerName: vendorDetails?.displayName,
        // productId: get_product_details?._id,
        // productName: get_product_details?.title,
        userName: enquiryData?.name,
        address: enquiryData?.address,
        // country,
        // countryCode,
        whatsappNo: enquiryData?.number,
        customerEmail: enquiryData?.email,
        message: enquiryData?.message,
        subject: "Inquiry From shop",
        // sellerEmail,
        // query,
      }),
    );

    console.log(response);
    if (response?.success) {
      setstatusDataBoxReturn(false);
      setenquiryData({
        name: "",
        email: "",
        number: "",
        address: "",
        message: "",
      });
    }
  };

  const [shareshow, setstshareshow] = useState(false);
  let pageUrl;

  if (typeof window !== "undefined") {
    if (window.location !== undefined) {
      // Outputs: 'https:'

      // Outputs: '/blog/react-get-current-url/'

      pageUrl = window.location.href;
    }
  }

  const [copied, setCopied] = useState(false);
  function copy() {
    const el = document.createElement("input");
    el.value = pageUrl;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // setCopied(true);
    toast.success("Copied!");

    setstshareshow(false);
  }

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    // Load the initial data
    fetchProducts();
  }, []);
  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  const fetchProducts = async () => {
    try {
      await delay(500);
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/gethomepageOnProduct?page=${page}&userid=${id}`,
      );
      const newProducts2 = await response.json();
      const newProducts = newProducts2?.data?.docs || [];
      // If no products are returned, set hasMore to false
      if (newProducts.length === 0) {
        setHasMore(false);
      }

      // Update products and increment page number
      setProducts((prevProducts) => [...prevProducts, ...newProducts]);
      setPage((prevPage) => prevPage + 1);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };
  useEffect(() => {
    dispatch(allapiAction.getsellerprofile({ id: id }));
    return () => {};
  }, []);
  return (
    <div>
      <Seo
        settitle={vendorDetails?.fullName}
        titleSeo={vendorDetails?.fullName}
        seoKeyword={vendorDetails?.fullName}
        seoconcal={"https://manglamart.com/vendor-store/" + vendorDetails?._id}
        seo_descriptions={vendorDetails?.fullName}
        title={vendorDetails?.fullName}
      />
      <CoustomberHeader />
      <div className="hometest">
        <HomeSliderSeller />
      </div>

      <Modal
        title="Enquiry Now !!"
        centered
        open={statusDataBoxReturn}
        onOk={() => hendletoSubmitEnquiry(false)}
        onCancel={() => setstatusDataBoxReturn(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Store Name</Col>
            <Col span={24}>
              <Input
                name="storename"
                placeholder="enter store name..."
                value={vendorDetails?.displayName}
                // onChange={(e) => {
                //   onChangeData(e);
                // }}
              />
            </Col>
            <Col span={24}>Name</Col>
            <Col span={24}>
              <Input
                name="name"
                placeholder="enter name..."
                value={enquiryData?.name}
                onChange={(e) => {
                  onChangeData(e);
                }}
              />
            </Col>
            <Col span={24}>Number</Col>
            <Col span={24}>
              <Input
                name="number"
                placeholder="enter number..."
                value={enquiryData?.number}
                onChange={(e) => {
                  onChangeData(e);
                }}
              />
            </Col>
            <Col span={24}>Email</Col>
            <Col span={24}>
              <Input
                name="email"
                placeholder="enter email..."
                value={enquiryData?.email}
                onChange={(e) => {
                  onChangeData(e);
                }}
              />
            </Col>
            <Col span={24}>Address</Col>
            <Col span={24}>
              <Input
                name="address"
                placeholder="enter address..."
                value={enquiryData?.address}
                onChange={(e) => {
                  onChangeData(e);
                }}
              />
            </Col>
            <Col span={24}>message</Col>
            <Col span={24}>
              <Input
                name="message"
                placeholder="enter message..."
                value={enquiryData?.message}
                onChange={(e) => {
                  onChangeData(e);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Share"
        centered
        open={shareshow}
        onOk={() => setstshareshow(false)}
        onCancel={() => setstshareshow(false)}
        width={500}
        footer={null}
      >
        <div>
          <div className="row unishareIcon">
            <div className="col-2 mt-3">
              <FacebookShareButton
                url={pageUrl}
                // quote={blog?.heading}
              >
                <FacebookIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </FacebookShareButton>
            </div>
            <div className="col-2 mt-3">
              <TwitterShareButton url={pageUrl}>
                <TwitterIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </TwitterShareButton>
            </div>
            <div className="col-2 mt-3">
              <WhatsappShareButton url={pageUrl}>
                <WhatsappIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </WhatsappShareButton>
            </div>
            <div className="col-2 mt-3">
              <LinkedinShareButton url={pageUrl}>
                <LinkedinIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </LinkedinShareButton>
            </div>
            <div className="col-2 mt-3">
              <EmailShareButton url={pageUrl}>
                <EmailIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </EmailShareButton>
            </div>
            <div className="col-2 mt-3">
              <MailruShareButton url={pageUrl}>
                <MailruIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </MailruShareButton>
            </div>
            <div className="col-2 mt-3">
              <OKShareButton url={pageUrl}>
                <OKIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </OKShareButton>
            </div>
            <div className="col-2 mt-3">
              <PinterestShareButton url={pageUrl}>
                <PinterestIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </PinterestShareButton>
            </div>
            <div className="col-2 mt-3">
              <PocketShareButton url={pageUrl}>
                <PocketIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </PocketShareButton>
            </div>
            <div className="col-2 mt-3">
              <RedditShareButton url={pageUrl}>
                <RedditIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </RedditShareButton>
            </div>
            <div className="col-2 mt-3">
              <TelegramShareButton url={pageUrl}>
                <TelegramIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </TelegramShareButton>
            </div>
            <div className="col-2 mt-3">
              <TumblrShareButton url={pageUrl}>
                <TumblrIcon
                  size={26}
                  round={true}
                  onClick={() => setstshareshow(false)}
                />
              </TumblrShareButton>
            </div>
          </div>

          <div className="shareLinkInModel">
            {" "}
            <p>
              <b>{pageUrl}</b>
            </p>
          </div>
          <div className="shareLinkInModel">
            <Button
              variant="primary"
              onClick={() => {
                copy();
                // onCloseModal();
              }}
            >
              {!copied ? "Copy link" : "Copied!"}
            </Button>
          </div>
        </div>
      </Modal>
      {/* <div className="marquee">
        <marquee behavior="scroll" direction="left" scrollamount="05">
          {vendorDetails?.displayName
            ? vendorDetails?.displayName
            : vendorDetails?.fullName}
        </marquee>
      </div> */}
      <div className="premium-marquee-container">
        <div className="marquee-wrapper">
          <div className="marquee-content">
            <span className="premium-badge">OFFICIAL STORE</span>
            <span className="vendor-marquee-text">
              {vendorDetails?.displayName || vendorDetails?.fullName}
            </span>
            {/* Repeat for continuous loop effect */}
            <span className="premium-badge">OFFICIAL STORE</span>
            <span className="vendor-marquee-text">
              {vendorDetails?.displayName || vendorDetails?.fullName}
            </span>
          </div>
        </div>
      </div>
      <div className="container-fluid vdstore">
        <div className="vendor-card-premium shadow-sm border rounded p-4 mb-4 bg-white">
          <div className="row align-items-center">
            {/* Profile Image Section */}
            <div className="col-md-3 col-12 text-center mb-3 mb-md-0">
              <div className="vendor-image-wrapper">
                <img
                  src={
                    vendorDetails?.sellerProfile
                      ? URL.API_BASE_URL + vendorDetails?.sellerProfile
                      : "/img/logo.png"
                  }
                  alt="Vendor"
                  className="img-fluid vendor-profile-img"
                  // className="img-fluid rounded-circle vendor-profile-img"
                />
              </div>
            </div>

            {/* Details Section */}
            <div className="col-md-9 col-12">
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div>
                  <h3 className="vendor-name mb-1">
                    {vendorDetails?.displayName || vendorDetails?.fullName}
                    <i
                      className="fa fa-check-circle text-primary ml-2"
                      title="Verified"
                    ></i>
                  </h3>
                  {vendorDetails?.category && (
                    <p className="vendor-category text-muted mb-2">
                      <i className="fa fa-tag mr-2"></i>{" "}
                      {vendorDetails?.category ? vendorDetails?.category : "--"}
                    </p>
                  )}
                  <p className="vendor-category text-muted mb-2 text-uppercase">
                    <i className="fa fa-tag mr-2"></i>{" "}
                    {vendorDetails?.retailertype}
                  </p>
                  <p className="vendor-location text-secondary mb-3">
                    <i className="fa fa-map-marker-alt mr-2"></i>{" "}
                    {vendorDetails?.city}, {vendorDetails?.state},{" "}
                    {vendorDetails?.country}
                  </p>
                </div>

                {/* Action Buttons (Follow/Like) */}
                <div className="vendor-actions d-flex gap-2">
                  {valuevendor || value
                    ? valueuser?._id !== id && (
                        <>
                          <button
                            className={`btn-premium ${get_like_list?.userFollow?.status === "active" ? "active" : ""}`}
                            onClick={hendletofollow}
                          >
                            {get_like_list?.userFollow?.status === "active" ? (
                              <i className="fa fa-user-check"></i>
                            ) : (
                              <i className="fa fa-user-plus"></i>
                            )}
                            <span className="ml-2">
                              {vendorDetails?.follower}{" "}
                              {get_like_list?.userFollow?.status === "active"
                                ? "Following"
                                : "Follow"}
                            </span>
                          </button>

                          <button
                            className={`btn-premium outline ml-2 ${get_like_list?.userlike?.status === "active" ? "active" : ""}`}
                            onClick={hendletoLike}
                          >
                            <i
                              className={
                                get_like_list?.userlike?.status === "active"
                                  ? "fa fa-thumbs-up"
                                  : "far fa-thumbs-up"
                              }
                            ></i>
                            <span className="ml-2">{vendorDetails?.like}</span>
                          </button>
                        </>
                      )
                    : null}
                </div>
              </div>

              <hr className="my-3" />

              {/* Footer Share & Social */}
              <div className="d-flex justify-content-between align-items-center">
                {/* <div className="social-quick-links">
           <button className="icon-btn-circle bg-soft-primary"><i className="fa fa-phone"></i></button>
           <button className="icon-btn-circle bg-soft-success ml-2"><i className="fab fa-whatsapp"></i></button>
           <button className="icon-btn-circle bg-soft-danger ml-2"><i className="fa fa-location-arrow"></i></button>
        </div> */}
                <div className="social-quick-links">
                  {/* Call Functionality */}
                  <button
                    className="icon-btn-circle bg-soft-primary"
                    onClick={() =>
                      (window.location.href = `tel:${vendorDetails?.phone || vendorDetails?.mobile}`)
                    }
                    title="Call Now"
                  >
                    <i className="fa fa-phone"></i>
                  </button>

                  {/* WhatsApp Functionality */}
                  <button
                    className="icon-btn-circle bg-soft-success ml-2"
                    onClick={() => {
                      const message = `Hello ${vendorDetails?.displayName || "Vendor"}, I saw your profile and I'm interested in your services.`;
                      window.open(
                        `https://wa.me/${vendorDetails?.phone || vendorDetails?.mobile}?text=${encodeURIComponent(message)}`,
                        "_blank",
                      );
                    }}
                    title="WhatsApp"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </button>

                  {/* Google Maps Functionality */}
                  {/* <button 
    className="icon-btn-circle bg-soft-danger ml-2" 
    onClick={() => {
      const address = `${vendorDetails?.city} ${vendorDetails?.state} ${vendorDetails?.zip} ${vendorDetails?.country}`;
      window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
    }}
    title="View Location"
  >
    <i className="fa fa-location-arrow"></i>
  </button> */}
                </div>
                <button
                  className="ps-btn-share"
                  onClick={() => setstshareshow(true)}
                >
                  <i className="fa fa-share-alt mr-2"></i> Share Profile
                </button>
              </div>
            </div>
          </div>
        </div>

        <Category homedata={get_home_all_pro} />
        {/* <Listing homedata={get_home_all_pro} /> */}
        <FeProduct homedata={get_home_all_pro} />
        {/* <RecentProduct homedata={get_home_all_pro} /> */}
        <div class="ps-product-list ps-clothings  ">
          <div class="ps-section__header my-5 border border-primary">
            <h3>Product</h3>
          </div>
        </div>
        <div className="ps-section__content mt-10">
          <InfiniteScroll
            dataLength={products.length} // Length of data loaded so far
            next={fetchProducts} // Function to load more data
            hasMore={hasMore} // Controls when to stop loading more
            loader={
              <div>
                <div className="spinnerContainer">
                  {/* <div class="spinner">
                            <span>L</span>
                            <span>O</span>
                            <span>A</span>
                            <span>D</span>
                            <span>I</span>
                            <span>N</span>
                            <span>G</span>
                          </div> */}
                  <section class="dots-container">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </section>
                </div>
              </div>
            } // Loading message/component
            endMessage={<p> </p>}
          >
            <div className="container-fluid">
              <div className="row">
                {products.map((data, index) => (
                  <div
                    className="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-2"
                    key={index}
                  >
                    <div className="recentlostfound">
                      <div className="ps-product">
                        <div className="ps-product__thumbnail  ps-product__thumbnailms2">
                          <Link
                            to={
                              data?.typeof == "Listing"
                                ? "/listing/" + data?.pro_sulg
                                : "/product/" + data?.pro_sulg
                            }
                          >
                            <CoustomImg
                              url={URL.API_BASE_URL + data?.featureImage}
                              altkey={data?.title}
                              w1={200}
                              w2={250}
                              h1={160}
                              h2={220}
                            />
                          </Link>
                        </div>
                        <div className="ps-product__container">
                          <div className="ps-product__content">
                            <Link
                              className="ps-product__title"
                              to={
                                data?.typeof == "Listing"
                                  ? "/listing/" + data?.pro_sulg
                                  : "/product/" + data?.pro_sulg
                              }
                            >
                              <TruncateText
                                text={data?.title}
                                maxLength={windowWidth > 600 ? 25 : 15}
                              />
                              {/* {data?.title} */}
                            </Link>

                            {data?.afterdiscountprice && (
                              <p className="ps-product__price sale">
                                ₹{data?.afterdiscountprice}{" "}
                                <del>₹{data?.price} </del>
                              </p>
                            )}
                            <Link
                              className="ps-product__vendor"
                              to={"/vendor-store/" + data?.sellerId?._id}
                            >
                              {data?.sellerId?.displayName}
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
}

export default SellerStore;
